import Highcharts from 'highcharts';
import Drilldown from 'highcharts/modules/drilldown';
// import drilldown from 'highcharts-drilldown';

if (!Highcharts.chart.prototype.addSeriesAsDrilldown) {
    Drilldown(Highcharts);
}

export default Highcharts;